/**
 * getUserAttributes module
 * Parses user attributes from cognito user
 */

import getCurrentUser from './getCurrentUser';

function getUserAttributes() {
  if (window.redirectBool) {
    return Promise.resolve({
      username: localStorage.zmailUsername,
      sub: localStorage.zmailUserId,
      email: localStorage.zmailEmail,
    });
  }

  var cognitoUser = getCurrentUser();
  var userAttributes = {};
  var userAttributesPromise = new Promise((resolve, reject) => {
    cognitoUser.getUserAttributes((err, result) => {
      if (err) {
        reject(err);
      } else {
        // Parse results from getUserAttributes into map object for simplicity
        for (var i = 0; i < result.length; i++) {
          userAttributes[result[i].getName()] = result[i].getValue();
        }

        // store id for userFunctions
        localStorage.zmailUserId = userAttributes.sub;
        resolve(userAttributes);
      }
    });
  });

  return userAttributesPromise;
}

export default getUserAttributes;



// WEBPACK FOOTER //
// ./src/authentication/getUserAttributes.js